import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { KIND_LABEL, servicesChanged } from "@/lib/services";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const EMPTY = { kind: "proxy", label: "", name: "", detail: "", note: "", due_day: "", warn_before: 1, critical: false };
const inp = "w-full rounded-lg border border-[#202D45] bg-[#0B0F17] px-3 py-2 text-sm text-slate-100 outline-none focus:border-orange-400/60";

export const ServiceForm = ({ open, item, onClose }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF(item ? { ...EMPTY, ...item, due_day: item.due_day ?? "" } : EMPTY); }, [open, item]);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const save = async () => {
    setBusy(true);
    const body = { kind: f.kind, label: f.label, name: f.name, detail: f.detail, note: f.note, due_day: f.due_day === "" ? null : Number(f.due_day), warn_before: Number(f.warn_before) || 1, critical: !!f.critical };
    try {
      if (item) await api.put(`/services/${item.id}`, body); else await api.post("/services", body);
      toast.success("Salvo"); servicesChanged(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao salvar"); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="service-form" className="border-[#1F293D] bg-[#0F141F] text-slate-100">
        <DialogHeader><DialogTitle>{item ? "Editar item" : "Novo item"}</DialogTitle></DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          <label className="text-xs text-slate-400">Tipo
            <select data-testid="service-form-kind" value={f.kind} onChange={set("kind")} className={inp}>
              {Object.entries(KIND_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select></label>
          <label className="text-xs text-slate-400">Nome (ex.: PROXY 08)
            <input data-testid="service-form-label" value={f.label} onChange={set("label")} className={inp} /></label>
          <label className="text-xs text-slate-400">Identificador (ex.: PHO-000000)
            <input data-testid="service-form-name" value={f.name} onChange={set("name")} className={inp} /></label>
          <label className="text-xs text-slate-400">Vence todo dia (vazio = sem vencimento)
            <input data-testid="service-form-due-day" type="number" min="1" max="31" value={f.due_day} onChange={set("due_day")} className={inp} /></label>
          <label className="text-xs text-slate-400">Começar a avisar quantos dias antes
            <input data-testid="service-form-warn-before" type="number" min="1" max="10" value={f.warn_before} onChange={set("warn_before")} className={inp} /></label>
          <label className="flex items-center gap-2 text-xs text-slate-300 sm:col-span-2">
            <input data-testid="service-form-critical" type="checkbox" checked={!!f.critical} onChange={(e) => setF((p) => ({ ...p, critical: e.target.checked }))} className="h-4 w-4 accent-orange-500" />
            Crítico: avisar o admin por SMS em cada dia do período de aviso (às 9h)
          </label>
          <label className="text-xs text-slate-400">Endereço / número
            <input data-testid="service-form-detail" value={f.detail} onChange={set("detail")} className={`${inp} font-mono`} /></label>
          <label className="text-xs text-slate-400 sm:col-span-2">Observação
            <input data-testid="service-form-note" value={f.note} onChange={set("note")} className={inp} /></label>
        </div>
        <button data-testid="service-form-save" disabled={busy} onClick={save}
          className="mt-2 rounded-lg bg-orange-500 py-2.5 text-sm font-bold text-slate-950 transition-opacity hover:opacity-90 disabled:opacity-50">Salvar</button>
      </DialogContent>
    </Dialog>
  );
};
